import { createApiCall, MethodType, URI } from "../Api";
import { ConsultationsPayload } from "models/consultations/consultationList";

export const getDashboardInfo = (payload: any) => {
  return createApiCall(MethodType.GET, URI.DASHBOARD.DASHBOARD_INFO, payload);
};
